var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cm-list" }, [
    _vm.commonData != undefined
      ? _c(
          "table",
          {
            staticClass: "cm-table",
            attrs: { width: "100%", cellspacing: "0", cellpadding: "0" }
          },
          [
            _c("tr", [
              _c("th", { attrs: { colspan: "3" } }, [
                _c("span", { staticClass: "tip pull-right" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v("基金名称\n\t\t\t")
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.commonData, function(item, key) {
              return _c(
                "tr",
                {
                  key: key,
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        path: "/funddetail/" + item.fund_code
                      })
                    }
                  }
                },
                [
                  _c("td", [
                    _c("p", { attrs: { title: item.fund_alias } }, [
                      _c("span", { class: [key <= "2" ? "ared" : ""] }, [
                        _vm._v(_vm._s(key + 1))
                      ]),
                      _vm._v(" " + _vm._s(item.fund_alias))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v("\n\t\t\t\t" + _vm._s(item.fund_code) + "\n\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "span",
                      {
                        class: [
                          item.col_value > 0
                            ? "ared"
                            : item.col_value < 0
                            ? "agreen"
                            : ""
                        ]
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("parseFloatFormat")(
                              item.col_value,
                              "--",
                              0,
                              1,
                              ""
                            )
                          ) + _vm._s(item.col_unit)
                        )
                      ]
                    )
                  ])
                ]
              )
            })
          ],
          2
        )
      : _c("div", { staticClass: "no-data" }, [_vm._m(0)])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无数据")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f18e99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f18e99","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commonlist.vue
// module id = null
// module chunks = 